import {Component} from '@angular/core';
import {ImageSliderComponent} from '../image-slider/image-slider.component';

@Component({
  selector: 'energylevel-slider',
  templateUrl: 'energylevel-slider.html',
  styleUrls: ['energylevel-slider.scss'],
})
export class EnergylevelSliderComponent extends ImageSliderComponent { }
